import { createFileRoute } from '@tanstack/react-router'

import { PharaohNextScope } from '#/lib/pharaoh-next/pharaoh-next-scope.tsx'
import { ResourcesIndexPage } from '#/modules/documentation/front-office/resources-index-page/resources-index-page.tsx'

export const Route = createFileRoute('/resources/')({
  component: () => (
    <PharaohNextScope>
      <ResourcesIndexPage />
    </PharaohNextScope>
  ),
})
